import { render, staticRenderFns } from "./Bankbay.vue?vue&type=template&id=3b7ece9a"
import script from "./Bankbay.vue?vue&type=script&lang=js"
export * from "./Bankbay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports